<template>
    <v-card :loading="loading" :disabled="loading">
<!--        <template slot="progress">-->
<!--            <v-progress-linear-->
<!--                color="deep-purple"-->
<!--                height="10"-->
<!--                indeterminate-->
<!--            ></v-progress-linear>-->
<!--        </template>-->

        <v-app-bar
            color="deep-purple accent-4"
            dark
        >
            <v-toolbar-title> {{ tabTitle }} </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn
                v-show="selectedTab == 0"
                color="pink"
                fab
                dark
                small
                @click="add"
            >
                <v-icon>mdi-plus</v-icon>
            </v-btn>

            <template v-if="isAdmin" v-slot:extension>
                <v-tabs
                    v-model="selectedTab"
                    align-with-title
                >
                    <v-tabs-slider color="purple"></v-tabs-slider>

                    <v-tab
                        v-for="item in tabs"
                        :key="item"
                    >
                        {{ item }}
                    </v-tab>
                </v-tabs>
            </template>
        </v-app-bar>

        <musteri-listesi v-if="selectedTab == 0" :loading.sync="loading"/>

        <kontrol-performansi v-if="selectedTab == 1" :loading.sync="loading"/>
    </v-card>
</template>

<script>
    import Vuex from 'vuex';
    import MusteriListesi from './MusteriListesi.vue';
    import KontrolPerformansi from './KontrolPerformansi.vue';

    export default {
        name: 'mak-musteriler',
        components: { MusteriListesi, KontrolPerformansi },
        data() {
            return {
                loading: false,
                selectedTab: 0,
                tabs: ['Liste', 'Performans'],
            };
        },
        computed: {
            ...Vuex.mapGetters(['isAdmin']),
            tabTitle() {
                return ['Müşteri Listesi', 'Kontroller Performansı'][this.selectedTab];
            },
        },
        methods: {
            add() {
                this.$router.push({name: 'musteri-kayit'});
            },
        },
    };
</script>
